
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Sidebar from '../../componentsUiBlock/Sidebar';
import Topbar from '../../componentsUiBlock/Topbar';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { useAuth } from '../../contexts/AuthContext';

const ControlPanel: React.FC = () => {
  const { isLoading } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const sidebarWidth = sidebarCollapsed ? 0 : 0; // Collapsed width is smaller

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      minHeight: '100vh',
      bgcolor: 'background.default',
      gap: 1,
      padding: 1.5
    }}>
      {/* Sidebar - Updated to accept collapse props */}
      <Sidebar
        layoutType='default'
        mobileOpen={mobileOpen}
        onMobileClose={handleDrawerClose}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleSidebar}
      />

      {/* Main content area */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        ml: { xs: 0, md: `${sidebarWidth}px` }, // Dynamic margin based on sidebar width
        width: { xs: '100%', md: `calc(100% - ${sidebarWidth}px)` }, // Dynamic width
        transition: theme => theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      }}>
        {/* Topbar - Updated to accept onMenuClick prop */}
        <Topbar onMenuClick={handleDrawerToggle} />

        {/* Main page content */}
        <Box
          component="main"
          sx={{
            flex: 1,
            py: { xs: 2, md: 3 },
            bgcolor: 'background.default',
            mt: { xs: 8, md: 5.4 } // Add top margin for mobile topbar
          }}
        >
          <Outlet />
        </Box>

        {/* Footer */}
        <Box
          component="footer"
          sx={{
            py: 2,
            px: 3,
            bgcolor: 'background.default',
            borderTop: '1px solid #ececec',
            textAlign: 'right'
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © 2026 JAI DURGE AUTOMOBILE & SERVICE STATION. All Rights Reserved.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ControlPanel;